module.exports = __webpack_public_path__ + "static/media/RW.bdb59980.png";